import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LeftLink from '../leftlink/leftlink.jsx';
import ChangePassword from '../myprofile/changepassword.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';


class NavChangePassword extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12 p-0 m-0">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{  }} >
                    <div className="row">
                        {/* <div className="col-sm-3 box-shadow-style nopadding">
                            <LeftLink />
                        </div> */}
                        <ToastContainer
                            position="top-right"
                            autoClose={5000}
                            hideProgressBar={false}
                            newestOnTop
                            closeOnClick
                            rtl={false}
                            pauseOnVisibilityChange
                            draggable
                            pauseOnHover
                             style={{ zIndex: 999999 }}
                        />
                        <div className="col-sm-12 m-0 p-0">
                            <div className="" style={{ minHeight: "476px" }}>
                           
                                <ChangePassword />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NavChangePassword;


// WEBPACK FOOTER //
// ./src/components/navchangepassword/navchangepassword.jsx